import { JSX, SVGProps } from 'react';

export const Vue = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 261.76 226.69" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m161.096.001-30.224 52.35L100.647.002H-.005L130.872 226.69 261.749 0z"
      fill="#41b883"
    />
    <path
      d="m161.096.001-30.224 52.35L100.647.002H52.346l78.526 136.01L209.398.001z"
      fill="#34495e"
    />
  </svg>
);
